import { gql, TypedDocumentNode } from "@apollo/client";

import { Role } from "types/generated";

type UserRoleData = {
  roles: Pick<Role, "id" | "name" | "slug" | "isSystem">[];
};

export const USER_ROLES_FOR_API_KEY_CREATION: TypedDocumentNode<UserRoleData> = gql`
  query UserRolesForApiKeyCreation {
    roles {
      id
      name
      slug
      isSystem
    }
  }
`;

export const CREATE_API_KEY = gql`
  mutation CreateApiKeyInDrawerV2($input: ApiKeyInput!) {
    apiKeyCreate(input: $input) {
      id
      name
      secret
      type
    }
  }
`;
